export default __webpack_public_path__ + "static/media/image-04.93d7e9f5.png";